import React from "react";

export const ErrorIllustration = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="148"
    height="148"
    viewBox="0 0 148 148"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="148" height="148" rx="74" fill="#ECEEF2" />
    <path
      d="M42.4319 120.821C42.4319 120.821 36.3825 120.841 36.3825 126.87C36.3825 120.841 30.3331 120.821 30.3331 120.821C30.3331 120.821 36.3825 120.8 36.3825 114.771C36.3825 120.8 42.4319 120.821 42.4319 120.821Z"
      fill="white"
      stroke="#8894A8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M90.4289 16.1516C90.4289 16.1516 84.3796 16.1721 84.3796 22.2009C84.3796 16.1721 78.3302 16.1516 78.3302 16.1516C78.3302 16.1516 84.3796 16.1309 84.3796 10.1022C84.3796 16.1309 90.4289 16.1516 90.4289 16.1516Z"
      fill="white"
      stroke="#8894A8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M63.2641 103.702H82.4344L84.6666 120.009H60.9006L63.2641 103.702Z"
      fill="#B2B9C7"
      stroke="#8894A8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M59.1448 103.702H78.3152L80.5473 120.009H56.7813L59.1448 103.702Z"
      fill="white"
      stroke="#8894A8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.2061 38.3126C25.2061 35.5285 27.463 33.2715 30.2472 33.2715H116.955C119.739 33.2715 121.996 35.5285 121.996 38.3126V98.8063C121.996 101.59 119.739 103.847 116.955 103.847H30.2472C27.463 103.847 25.2061 101.59 25.2061 98.8063V38.3126Z"
      fill="#D6DAE1"
      stroke="#8894A8"
    />
    <path
      d="M19.1563 38.3127C19.1563 35.5285 21.4133 33.2715 24.1975 33.2715H110.905C113.689 33.2715 115.946 35.5285 115.946 38.3127V98.8063C115.946 101.59 113.689 103.847 110.905 103.847H24.1974C21.4133 103.847 19.1563 101.59 19.1563 98.8063V38.3127Z"
      fill="white"
      stroke="#8894A8"
    />
    <path
      d="M19.1563 88.7241H109.897C112.681 88.7241 114.938 90.9811 114.938 93.7652V98.8063C114.938 101.59 112.681 103.847 109.897 103.847H24.1974C21.4133 103.847 19.1563 101.59 19.1563 98.8063V88.7241Z"
      fill="#8894A8"
    />
    <path
      d="M45.073 62.2928L42.8047 60.0244"
      stroke="#8894A8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M31.282 60.0244L29.0137 62.2928"
      stroke="#8894A8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.9711 47.0183C38.0682 45.321 42.7645 47.2662 44.4617 51.3632C46.159 55.4603 44.2128 60.1566 40.1167 61.8528C36.0197 63.5501 31.3234 61.6039 29.6272 57.5078C27.9299 53.4118 29.8751 48.7145 33.9711 47.0183"
      stroke="#8894A8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.793 50.853V55.0033L40.055 56.9926"
      stroke="#8894A8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.5416 44.4977C31.3402 44.1564 29.9983 44.4425 29.0528 45.3879C28.2388 46.2029 27.9156 47.313 28.0561 48.3739"
      stroke="#8894A8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41.5594 44.4977C42.7609 44.1564 44.1018 44.4425 45.0473 45.3879C45.8623 46.2029 46.1855 47.313 46.0449 48.3739"
      stroke="#8894A8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="55.7236"
      y="42.998"
      width="7.85508"
      height="7.85508"
      rx="0.980636"
      fill="#D6DAE1"
    />
    <rect
      x="55.7236"
      y="58.3657"
      width="7.85508"
      height="7.85508"
      rx="0.980636"
      fill="#D6DAE1"
    />
    <rect
      x="70.2117"
      y="44.569"
      width="35.3418"
      height="3.80468"
      rx="0.980636"
      fill="#D6DAE1"
    />
    <rect
      x="70.2117"
      y="60.5638"
      width="20.7523"
      height="3.80468"
      rx="0.980636"
      fill="#D6DAE1"
    />
    <rect
      x="29.2217"
      y="72.5015"
      width="7.85508"
      height="7.85508"
      rx="0.980636"
      fill="#D6DAE1"
    />
    <rect
      x="43.998"
      y="74.5273"
      width="43.6365"
      height="3.80468"
      rx="0.980636"
      fill="#D6DAE1"
    />
    <circle
      cx="67.6026"
      cy="96.3586"
      r="3.44035"
      fill="white"
      stroke="#8894A8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M116.923 123.203L80.2191 123.18C80.117 123.18 80.0208 123.174 79.9247 123.168C79.9187 123.174 79.9127 123.174 79.9066 123.168C79.7924 123.18 79.6783 123.18 79.5641 123.18C75.7182 123.177 72.6073 120.063 72.6097 116.217C72.6112 113.885 73.7601 111.825 75.5216 110.558C76.6579 109.741 78.0583 109.262 79.5727 109.262L115.385 104.381C110.883 105.123 107.456 109.021 107.453 113.726C107.45 118.954 111.689 123.199 116.923 123.203Z"
      fill="#D6DAE1"
      stroke="#8894A8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M126.401 78.0298L126.399 113.738C126.395 118.966 122.15 123.206 116.922 123.203C111.688 123.199 107.448 118.954 107.452 113.726C107.454 109.021 110.882 105.123 115.383 104.381L79.5716 109.262C78.0572 109.261 76.6568 109.741 75.5205 110.558L75.5211 77.9986C75.5227 75.3966 77.6333 73.2887 80.2293 73.2903L121.699 73.3157C124.301 73.3174 126.403 75.4278 126.401 78.0298Z"
      fill="white"
      stroke="#8894A8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M85.7822 82.7314L93.4582 90.3796"
      stroke="#8894A8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M93.4435 82.7174L85.7953 90.3934"
      stroke="#8894A8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M109.188 82.688L116.864 90.3362"
      stroke="#8894A8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M116.849 82.6743L109.201 90.3503"
      stroke="#8894A8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M90.5898 98.2612L110.456 98.2252"
      stroke="#8894A8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
